import { addMinutes, subWeeks } from 'date-fns';
import { uniqueId } from 'lodash';

import { SESSION_LENGTH_MINUTES } from './constants';
import { type ClassSession } from '../types';

export const makeClassSessions = ({ count }: { count: number }) => {
    const classId = '422010';
    const timezone = 'US/Eastern';
    const sessions: ClassSession[] = [];

    for (let i = 0; i < count; i++) {
        const date = new Date();

        sessions.push({
            session_id: uniqueId(),
            class_id: classId,
            timezone,
            start_time: subWeeks(date, i).toISOString(),
            end_time: subWeeks(addMinutes(date, SESSION_LENGTH_MINUTES), i).toISOString(),
            last_updated: subWeeks(date, 1).toISOString(),
            attendance_generated: null,
            topic: `Session ${i}`
        });
    }

    return sessions;
};
